import { AuthGuard, CrudOp, geometryAuthScope, targetAuthScope, tmmAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const GeometryManagerView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  const tmmId = useRequiredSubprojectParam("tmmId");
  const projectId = useRequiredProjectParam("projectId");
  return (
    <AuthGuard authScope={geometryAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <AuthGuard authScope={targetAuthScope} crudOp={CrudOp.READ}>
        <AuthGuard authScope={tmmAuthScope} crudOp={CrudOp.READ} project={projectId}>
          <Suspense><LazyGeometryManagerView brand={brand} tmmId={tmmId}/></Suspense>
        </AuthGuard>
      </AuthGuard>
    </AuthGuard>
  );
};

const LazyGeometryManagerView = lazy(importView(
  () => import("../components/GeometryManagerView"),
  (it) => it.GeometryManagerView,
));
